<template>
  <main class="flex">
    <div class="w-full h-full flex flex-col gap-3 sm:gap-8">
      <Section_1/>
      <Section_2/>
<!--      <Section_3/>-->
      <Section_4/>
      <Section_5/>
      <Section_6/>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Main',
}
</script>